import type ApplicationInstance from '@ember/application/instance';

const Application: { instance?: ApplicationInstance } = { instance: undefined };

export default Application;
